import React from 'react';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import bannerImage from './images/box.png';
import mobileBannerImage from './images/box--mobile.png';
import './index.sass';

const { block } = bem('banner');
const Banner = () => {
    const { isMobile } = useMobile();
    return <div className={block()}>
        <img src={isMobile ? mobileBannerImage : bannerImage} />
    </div>
}

export default Banner;
